import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';

import { PracticeSubject } from '../types';

import {
  getAvailableExercisesForPracticeQuery,
  GetAvailableExercisesForPracticeResult,
  GetAvailableExercisesForPracticeVariables,
} from '../graphql/queries/getAvailableExercisesForPracticeQuery';

export interface AvailableExercisesHookInput {
  courseId?: string;
}

export interface AvailableExercisesHookPayload {
  error?: string;
  loading: boolean;
  availableExercisesCount: number;
  subjects?: PracticeSubject[];

  refetchAvailableExercises: () => void;
}

export default function useAvailableExercises({ courseId }: AvailableExercisesHookInput): AvailableExercisesHookPayload {
  const { data, loading, error, refetch } = useQuery<GetAvailableExercisesForPracticeResult, GetAvailableExercisesForPracticeVariables>(
    getAvailableExercisesForPracticeQuery,
    {
      variables: { courseId: courseId || '' },
      skip: !courseId,
      fetchPolicy: 'cache-and-network',
    }
  );
  return {
    availableExercisesCount: data?.availableExercisesPayload?.availableExercises || 0,
    subjects: data?.availableExercisesPayload?.subjects,
    error: getErrorMessage({ error }),
    loading,
    refetchAvailableExercises: refetch,
  };
}
